import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import {
  BenefitProductClassResponse,
  completePerksEmployeeClasses,
  getBenefitProductClasses,
  getPerksClassTypes,
} from 'core'

import useCommandRequest from 'common/hooks/useCommandRequest'

import { Col, Row, Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import { BaseComponentProps } from '../../common/models'
import { ProductClassForm } from './productClassForm'

import './styles.less'

export type PerksEmployeeClassesProps = {
  planPeriodId: string
}

const PerksEmployeeClasses: React.FC<BaseComponentProps<PerksEmployeeClassesProps>> = (props) => {
  const { bindSubmitFormHandler } = props
  const { t: translate } = useTranslation()
  const [productClassValues, setProductClassValues] = useState([])

  const { data: productClasses, reload: reloadProductClasses } = useQueryRequestV2<BenefitProductClassResponse[]>({
    queryFn: () => {
      return getBenefitProductClasses(props.state.planPeriodId)
    },
  })

  const [sendCommand] = useCommandRequest()

  const [productClassFormValues, setProductClassFormValues] = useState<any>({
    planPeriodId: props.state.planPeriodId,
  })
  const { data: classTypes, reload: reloadClassTypes } = useQueryRequestV2({
    queryFn: () => {
      return getPerksClassTypes(props.state.planPeriodId)
    },
  })
  const formValidator = (translate: any) => Yup.object({})

  const onProductClassSaved = () => {
    reloadClassTypes().then(() => setProductClassFormValues({ planPeriodId: props.state.planPeriodId }))
  }

  const onSubmit = async () => {
    var productClassesValuesRequest = productClassValues.map((x) => ({
      id: x.id,
      classTypeId: x.classTypeId,
    }))

    const result = await sendCommand(() =>
      completePerksEmployeeClasses({
        productClasses: productClassesValuesRequest,
        planPeriodId: props.state.planPeriodId,
      }),
    )

    if (result.completed) {
      onProductClassSaved()
      props.goNext()
    } else {
      props.setIsSubmiting(false)
    }
  }

  useEffect(() => {
    setProductClassValues(
      productClasses?.map((c) => ({
        id: c.id,
        classTypeId: c.classTypeId,
        name: c.name,
      })) || [],
    )
  }, [productClasses])

  useEffect(() => {
    props.setIsFormValid(productClassValues?.length > 0)
  }, [productClassValues])
  return (
    <>
      <Formik
        enableReinitialize={true}
        validationSchema={formValidator(translate)}
        initialValues={props.state}
        onSubmit={onSubmit}
        validate={(values) => {
          props.hasDirtyData(true)
          props.setIsFormValid(formValidator(translate).isValidSync(values))
          return {}
        }}
      >
        {(formik) => {
          const { handleSubmit, submitForm } = formik
          bindSubmitFormHandler(submitForm)
          return (
            <form onSubmit={handleSubmit} autoComplete="off" className={'perks-employee-classes-wrapper'}>
              <Row className={'mb-32'}>
                <Col span={17} className={'benefit_design_page_header mb-24'}>
                  <h5>{translate('admin-dashboard.benefit-details.perks-benefit-create-eligible-classes.header')}</h5>
                  <h6 className={'inline mr-8'}>
                    {translate('admin-dashboard.benefit-details.perks-benefit-create-eligible-classes.subheader')}
                  </h6>
                </Col>
                <Col span={24} className={'benefit_design_page_header'}>
                  <Skeleton loading={!productClasses}>
                    {productClasses && (
                      <>
                        <ProductClassForm
                          initialValues={productClassFormValues}
                          productClasses={productClassValues}
                          classTypes={classTypes}
                          onChangeProductClassValues={setProductClassValues}
                          onProductClassSaved={onProductClassSaved}
                        />
                      </>
                    )}
                  </Skeleton>
                </Col>
              </Row>
            </form>
          )
        }}
      </Formik>
    </>
  )
}

export default PerksEmployeeClasses
